import { DateTime } from 'luxon';

/**
 * Formats a date to 'Mon, 29. Oct 2024.'
 * @param date DateTime object or string
 * @returns Formatted date string or 'Invalid Date'
 */
export const formatToWeekdayMonthDayYear = (date: DateTime | string): string => {
    const parsedDate = DateTime.isDateTime(date) ? date : DateTime.fromISO(date);
    if (!parsedDate.isValid) return 'Invalid Date';

    return parsedDate.toFormat('EEE, dd. LLL yyyy.');
};

/**
 * Formats a date to '29. Oct 2024.'
 * @param date DateTime object or string
 * @returns Formatted date string or 'Invalid Date'
 */
export const formatToMonthDayYear = (date: DateTime | string): string => {
    const parsedDate = DateTime.isDateTime(date) ? date : DateTime.fromISO(date);
    if (!parsedDate.isValid) return 'Invalid Date';

    return parsedDate.toFormat('dd. LLL yyyy.');
};

/**
 * Formats a date to '29. Oct.'
 * @param date DateTime object or string
 * @returns Formatted date string or 'Invalid Date'
 */
export const formatToMonthDay = (date: DateTime | string): string => {
    const parsedDate = DateTime.isDateTime(date) ? date : DateTime.fromISO(date);
    if (!parsedDate.isValid) return 'Invalid Date';

    return parsedDate.toFormat('dd. LLL');
};

/**
 * Formats a date to 'December 7, 2024'
 * @param date DateTime object or string
 * @returns Formatted date string or 'Invalid Date'
 */
export const formatToFullMonthDayYear = (date: DateTime | string): string => {
    const parsedDate = DateTime.isDateTime(date) ? date : DateTime.fromISO(date);
    if (!parsedDate.isValid) return 'Invalid Date';

    return parsedDate.toFormat('MMMM d, yyyy');
};
